<h3>{{this.model.dataProtection?.heading ?? 'Declarations'}}</h3>
<hr>
@if(showLegalText) {
  <p>
    @for(segment of legalTextSegments; track $index) {
              @if(segment.link) {
                <a class="link-button" (click)="handleLinkClick(segment)">{{segment.text}}</a>
              } @else {
                {{segment.text}}
              }
            }
  </p>
}

@if(showMandatoryQuestion) {
 
        <div class="question-text required" >
            @for(segment of mandatoryQuestionSegments; track $index) {
              @if(segment.link) {
                <a class="link-button" (click)="handleLinkClick(segment)">{{segment.text}}</a>
              } @else {
                {{segment.text}}
              }
            }
          </div>
    <app-radio-input
            [label]="''"
            [control]="dataProtectionForm.controls.mandatoryQuestion"
            [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]">
    </app-radio-input>

}
@if(showOptionalQuestion1 && model.dataProtection?.optionalQuestion1?.question) {
<div class="question-text required" >
            @for(segment of optionalQuestion1Segments; track $index) {
              @if(segment.link) {
                <a class="link-button" (click)="handleLinkClick(segment)">{{segment.text}}</a>
              } @else {
                {{segment.text}}
              }
            }
        </div>

    <app-radio-input
            [label]="''"
            [control]="dataProtectionForm.controls.optionalQuestion1"
            [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]"
            [errorMsg]="'Please select Yes or No'">
    </app-radio-input>

}
@if(showOptionalQuestion2 && model.dataProtection?.optionalQuestion2?.question) {
    <div class="question-text required" >
            @for(segment of optionalQuestion2Segments; track $index) {
              @if(segment.link) {
                <a class="link-button" (click)="handleLinkClick(segment)">{{segment.text}}</a>
              } @else {
                {{segment.text}}
              }
            }
        </div>
    <app-radio-input
            [label]="''"
            [control]="dataProtectionForm.controls.optionalQuestion2"
            [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]"
            [errorMsg]="'Please select Yes or No'">
    </app-radio-input>

}
@if(showOptionalQuestion3 && model.dataProtection?.optionalQuestion3?.question) {
    <div class="question-text required">
            @for(segment of optionalQuestion3Segments; track $index) {
              @if(segment.link) {
                <a class="link-button" (click)="handleLinkClick(segment)">{{segment.text}}</a>
              } @else {
                {{segment.text}}
              }
            }
          </div>
    <app-radio-input
            [label]="''"
            [control]="dataProtectionForm.controls.optionalQuestion3"
            [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]"
            [errorMsg]="'Please select Yes or No'">
    </app-radio-input>

}
@if(showStandardDeclaration && model.dataProtection?.standardDeclaration?.question) {
  
        <div class="icon-container">
         <mat-icon fontSet="material-symbols-outlined">lock</mat-icon>
         </div> 
        <div class="question-text required">
            @for(segment of standardDeclarationSegments; track $index) {
              @if(segment.link) {
                <a class="link-button" (click)="handleLinkClick(segment)">{{segment.text}}</a>
              } @else {
                {{segment.text}}
              }
            }
          </div>
        <mat-checkbox 
            [formControl]="dataProtectionForm.controls.standardDeclaration">
            I Agree
        </mat-checkbox>
   
}
@if(showDataProcessorNotice) {

        <div class="icon-container">
         <mat-icon fontSet="material-symbols-outlined">lock</mat-icon>
         </div>
       <div class="question-text">
            @for(segment of dataProcessorNoticeSegments; track $index) {
              @if(segment.link) {
                <a class="link-button" (click)="handleLinkClick(segment)">{{segment.text}}</a>
              } @else {
                {{segment.text}}
              }
            }
        </div>
 
}